// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.product-list-container {
  width: calc(100% - 40px);
  max-width: 600px;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #dc3545;
  display: flex;
  flex-direction: column;
  margin-left: 50px; /* Extra space for margin */
  height: 640px;
 
}

/* Search bar styles */
.search-bar {
  margin-bottom: 20px;
}

.search-bar-input {
  width: 100%;
  font-size: 16px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.search-bar-input:focus {
  outline: none;
  border-color: #73ad06;
}

/* Message styles */
.message {
  background-color: #dff0d8;
  color: #3c763d;
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 16px;
}

/* Table container for scrollable body */
.product-table-container {
  overflow-x: auto;
  max-height: 600px;
  display: block;
}

/* Table styles */
.product-table {
  width: 100%;
  border-collapse: collapse;
}

.product-table th,
.product-table td {
  border: 1px solid #665e5e;
  text-align: left;
  padding: 8px;
}

.product-table th {
  background-color: #7cc7f3;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Button styles */
.button-product-list {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 5px;
  margin: 0 5px;
  font-size: 16px;
}

.button-product-list .faEdit {
  color: #007bff;
}

.button-product-list .faTrash {
  color: #dc3545;
}

/* Hover effect for buttons */
.button-product-list:hover {
  background-color: #f35e5e;
  border-radius: 4px;
}

/* Animation for fade-in effect */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Confirmation dialog styles */
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.confirm-button,
.cancel-button {
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 10px;
  font-size: 16px;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

/* Media query for responsive design */
@media screen and (max-width: 768px) {
  .product-list-container {
    width: calc(100% - 20px); /* Adjust width for mobile */
    margin: 20px;
    margin-left: 0; /* No extra margin on smaller screens */
  }

  .search-bar-input {
    width: calc(100% - 20px);
  }

  .product-table-container {
    max-height: 300px;
  }

  .message {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/ProductManagement/ProductList/ProductList.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,2BAA2B;EAC9C,aAAa;;AAEf;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE;IACE,wBAAwB,EAAE,4BAA4B;IACtD,YAAY;IACZ,cAAc,EAAE,uCAAuC;EACzD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["\n.product-list-container {\n  width: calc(100% - 40px);\n  max-width: 600px;\n  border-radius: 10px;\n  padding: 10px;\n  border: 1px solid #dc3545;\n  display: flex;\n  flex-direction: column;\n  margin-left: 50px; /* Extra space for margin */\n  height: 640px;\n \n}\n\n/* Search bar styles */\n.search-bar {\n  margin-bottom: 20px;\n}\n\n.search-bar-input {\n  width: 100%;\n  font-size: 16px;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.search-bar-input:focus {\n  outline: none;\n  border-color: #73ad06;\n}\n\n/* Message styles */\n.message {\n  background-color: #dff0d8;\n  color: #3c763d;\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n/* Table container for scrollable body */\n.product-table-container {\n  overflow-x: auto;\n  max-height: 600px;\n  display: block;\n}\n\n/* Table styles */\n.product-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.product-table th,\n.product-table td {\n  border: 1px solid #665e5e;\n  text-align: left;\n  padding: 8px;\n}\n\n.product-table th {\n  background-color: #7cc7f3;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* Button styles */\n.button-product-list {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 5px;\n  margin: 0 5px;\n  font-size: 16px;\n}\n\n.button-product-list .faEdit {\n  color: #007bff;\n}\n\n.button-product-list .faTrash {\n  color: #dc3545;\n}\n\n/* Hover effect for buttons */\n.button-product-list:hover {\n  background-color: #f35e5e;\n  border-radius: 4px;\n}\n\n/* Animation for fade-in effect */\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Confirmation dialog styles */\n.confirm-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.confirm-dialog {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.confirm-button,\n.cancel-button {\n  border: none;\n  cursor: pointer;\n  padding: 10px 20px;\n  border-radius: 5px;\n  margin: 10px;\n  font-size: 16px;\n}\n\n.confirm-button {\n  background-color: #28a745;\n  color: white;\n}\n\n.cancel-button {\n  background-color: #dc3545;\n  color: white;\n}\n\n/* Media query for responsive design */\n@media screen and (max-width: 768px) {\n  .product-list-container {\n    width: calc(100% - 20px); /* Adjust width for mobile */\n    margin: 20px;\n    margin-left: 0; /* No extra margin on smaller screens */\n  }\n\n  .search-bar-input {\n    width: calc(100% - 20px);\n  }\n\n  .product-table-container {\n    max-height: 300px;\n  }\n\n  .message {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
